// extracted by mini-css-extract-plugin
export default {"timer":"F0-z","loaded":"G0-z"};